module.exports = __webpack_public_path__ + "static/media/mountains.1075b1d0.svg";